import { Sparkles } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { isCrmRole } from '../../lib/roles';

/**
 * "Brief me" on a client: opens Scout with the question already asked, so the
 * rep walking into a meeting gets the pre-visit brief (brief_customer, api#1077)
 * in one tap.
 *
 * The question travels in router STATE, not the URL: a customer name in a query
 * string ends up in history, logs and anything that shares the link. The chat
 * screen sends it once and clears the state, so Back and a reload do not ask
 * again. It is an ordinary read; nothing is written.
 *
 * CRM_ROLES only — brief_customer is a CRM_TOOL_ROLES tool. Whether Scout's
 * mode lets THIS caller use it is the API's call, made per turn; when it does
 * not, the assistant says so in the chat rather than this button guessing.
 */
export const SCOUT_ASK_STATE = 'scoutAsk';

export function briefMeQuestion(customerName: string): string {
  return `Brief me on ${customerName}`;
}

export default function BriefMeButton({ customerName }: { customerName: string | null | undefined }) {
  const navigate = useNavigate();
  const { user } = useAuth();
  if (!isCrmRole(user?.role) || !customerName?.trim()) return null;
  return (
    <button
      type="button"
      onClick={() => navigate('/agent', { state: { [SCOUT_ASK_STATE]: briefMeQuestion(customerName.trim()) } })}
      className="flex items-center gap-2 px-3 py-2 bg-fieldiq-card border border-fieldiq-border text-white font-semibold rounded-lg text-sm hover:bg-fieldiq-card/80 transition-colors"
      data-testid="brief-me"
    >
      <Sparkles size={14} aria-hidden="true" />
      Brief me
    </button>
  );
}
